<app-overlay
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [container]="container"
  [overlayMask]="false"
  [animate]="false"
  (onContentReady)="onContentReadyInternal()"
>
  <ng-template overlayContent>
    <div
      class="tooltip alignment-vertical-{{
        verticalAlignment
      }} alignment-horizontal-{{ horizontalAlignment }}"
      #tooltipEl
    >
      <div class="tooltip-content">
        <ng-container *ngIf="!contentTpl?.templateRef; else contentTplRef">
          <ng-content></ng-content>
        </ng-container>

        <ng-template #contentTplRef>
          <ng-template
            [ngTemplateOutlet]="contentTpl.templateRef"
          ></ng-template>
        </ng-template>
      </div>
    </div>
  </ng-template>
</app-overlay>
